// Runtime loader for Module Federation
const loadedScripts = new Map();
const loadedContainers = new Map();

const loadScript = (url) => {
  if (loadedScripts.has(url)) {
    return loadedScripts.get(url);
  }
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    script.onerror = () => {
      loadedScripts.delete(url);
      script.remove();
      reject(new Error(`Failed to load remote container script: ${url}`));
    };
    document.head.appendChild(script);
  });
  loadedScripts.set(url, promise);
  return promise;
};

const resolveContainer = async (
  remoteEntryUrl,
  containerName,
  exposedModule,
) => {
  await loadScript(remoteEntryUrl);
  const container = window[containerName];
  if (!container) {
    throw new Error(
      `Remote container "${containerName}" did not attach to window after loading ${remoteEntryUrl}`,
    );
  }
  // Empty scope: the container owns and eager-loads its shared modules.
  await container.init({});
  const factory = await container.get(exposedModule);
  return factory();
};

export const loadRemoteContainer = (
  remoteEntryUrl,
  containerName,
  exposedModule,
) => {
  const key = `${remoteEntryUrl}|${containerName}|${exposedModule}`;
  if (!loadedContainers.has(key)) {
    const promise = resolveContainer(
      remoteEntryUrl,
      containerName,
      exposedModule,
    );
    promise.catch(() => loadedContainers.delete(key));
    loadedContainers.set(key, promise);
  }
  return loadedContainers.get(key);
};
